module.exports = __webpack_public_path__ + "assets/paige_404.d9697994.png";